// Google Analytics 4: caricato solo dopo il consenso ai cookie di misurazione e marketing (vedi CookieConsent.js)
const MEASUREMENT_ID = "G-D13SGH4CKN";

export const loadGoogleAnalytics = () => {
  if (window.gtag) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Le pagine viste successive (navigazione interna della SPA) le rileva la misurazione avanzata di GA4
  window.gtag("config", MEASUREMENT_ID);
};

// Elimina i cookie di Analytics già installati (alla revoca del consenso)
export const removeGoogleAnalyticsCookies = () => {
  const host = window.location.hostname;
  const domains = ["", host, `.${host.replace(/^www\./, "")}`];
  document.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((name) => name === "_ga" || name.startsWith("_ga_"))
    .forEach((name) => {
      domains.forEach((domain) => {
        document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ""}`;
      });
    });
};
